import { refuseUnported } from '../janus-engine/unported.js';
import { encounterField } from '../shared/array-types.js';

type Row = Record<string, unknown>;
type WarmupResult = { name: string; ok: boolean; error?: string };
const warmups = new Map<string, (encounter: Row, actorId?: string) => Promise<WarmupResult>>();
type WarmupState = { name: string; encounterId: string; actorId?: string; at: number; endedAt?: number; state: string };
const states: WarmupState[] = [];
export function registerActionInputWarmup(name: string, wait: (encounter: Row, actorId?: string) => Promise<boolean>): void {
    warmups.set(name, async (encounter, actorId) => {
        const state: WarmupState = { name, encounterId: String(encounterField(encounter, 'encounter_id') ?? ''), actorId,
            at: Date.now(), state: 'pending' };
        states.push(state);
        if (states.length > 128) states.shift();
        try { const ok = await wait(encounter, actorId); state.state = ok ? 'ready' : 'refused'; return { name, ok }; }
        catch (error) { state.state = String(error); return { name, ok: false, error: error instanceof Error ? error.message : String(error) }; }
        finally { state.endedAt = Date.now(); }
    });
}
Object.assign(window, { ftActionInputWarmupState: () => states.map(state => ({ ...state })) });
async function awaitWarmups(ids: readonly string[], actorId: string | undefined, inputs: readonly string[]): Promise<boolean> {
    const encounters = new Set(ids.map(id => window.FateTide?.encounterCache?.get(id.toUpperCase()) as Row | undefined)
        .filter((encounter): encounter is Row => !!encounter));
    for (const encounter of encounters) {
        const results = await Promise.all(inputs.map((name): Promise<WarmupResult> | WarmupResult =>
            warmups.get(name)?.(encounter, actorId) ?? { name, ok: true }));
        const failed = results.find(result => !result.ok);
        if (failed) { refuseUnported(`action-preload:${failed.name}-unavailable`, failed.error ? { error: failed.error } : undefined); return false; }
    }
    return true;
}
/** A boundary joins its own adoption job, never another lane's preload. */
Object.assign(window, { ftAwaitActionInputWarmups: awaitWarmups,
    ftAwaitActionInputs: (ids: readonly string[], actorId?: string) => awaitWarmups(ids, actorId, [...warmups.keys()]) });
